export const state = (): Auth => ({
  fw_token: "",
  fw_token_timestamp: 0,
  user: null
})

export const GET_FW_TOKEN = "getFwToken"
export const GET_FW_TOKEN_TIMESTAMP = "getFwTokenTimestamp"
export const GET_USER = "getUser"

export const getters = {
  [GET_FW_TOKEN]: (state: Auth): string => state.fw_token,
  [GET_FW_TOKEN_TIMESTAMP]: (state: Auth): number => state.fw_token_timestamp,
  [GET_USER]: (state: Auth): Object | null => state.user
}

export const _SET_FW_TOKEN = "setFwToken"
export const _SET_USER = "setUser"

export const mutations = {
  [_SET_FW_TOKEN](state: Auth, token: string) {
    state.fw_token = token
    state.fw_token_timestamp = Math.floor(Date.now() / 1000)
  },
  [_SET_USER](state: Auth, user: Object) {
    state.user = user
  }
}

export const SET_FW_TOKEN = "setFwToken"
export const SET_USER = "setUser"

export const actions = {
  [SET_FW_TOKEN]({ commit }, token: string) {
    commit(_SET_FW_TOKEN, token)
  },
  [SET_USER]({ commit }, user: Object) {
    commit(_SET_USER, user)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
